import { Box, Typography } from "@mui/material";
import { useSharedColors } from "@ippon/shared-components";

interface ContractGraceBannerProps {
  /** 案内の文言（contractApi の buildGraceNotice で作る） */
  message: string;
}

/**
 * 解約後の猶予期間の案内（管理画面化 SPEC §7.4.6）。
 * 契約終了日の 3 か月後まではデータの確認のためにログインできるが、AI 機能は使えないことを知らせる。
 */
const ContractGraceBanner: React.FC<ContractGraceBannerProps> = ({ message }) => {
  const colors = useSharedColors();
  return (
    <Box
      role="status"
      sx={{
        mx: { xs: 2, md: 3 },
        mt: 2,
        px: 2,
        py: 1.5,
        borderRadius: "8px",
        border: `1px solid ${colors.status.warning}`,
        backgroundColor: colors.background.default,
      }}
    >
      <Typography sx={{ fontSize: "13px", color: colors.text.primary }}>{message}</Typography>
    </Box>
  );
};

export default ContractGraceBanner;
